import * as React from 'react';
import { getConfigOrThrow, PageTitle, VideoContainer } from 'gossamer-front-end';
import { Button, Stack, Tab, Tabs } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { EventFutureSearch } from './EventFutureSearch';
import { EventPastSearch } from './EventPastSearch';
import { OnDemandEventSearch } from './OnDemandEventSearch';
import { CancelledEventSearch } from './CancelledEventSearch';
import { DownloadButton } from 'packages/shared-front-end';

export const EventSearch = (): React.JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <>
      <PageTitle title="Search for Events" subtitle="Find future, past or on-demand events for your institution" />

      <Stack direction="horizontal" gap={2} className="mb-3">
        <Link to="/admin/event/create">
          <Button size="sm" variant="primary">
            Create an Event
          </Button>
        </Link>

        <Link to="/admin/event/bulk-upload">
          <Button size="sm" variant="primary">
            Bulk Upload Events
          </Button>
        </Link>

        <DownloadButton
          url={[getConfigOrThrow('gossamer-be-origin'), 'gossamer/main/admin-print-bulk-qr-codes'].join('/')}
          title="Download PDF of the next 7 days of tracked events for your institution"
        >
          <Button size="sm" variant="secondary">
            Download Next 7 Days' Tracked Event QR Codes for Printing
          </Button>
        </DownloadButton>
      </Stack>

      <Tabs
        activeKey={searchParams.get('tab') || 'future'}
        variant="underline"
        className="mb-3"
        mountOnEnter={true}
        unmountOnExit={true}
        onSelect={(tab) => {
          const newParams = new URLSearchParams();
          newParams.set('tab', tab);
          setSearchParams(newParams);
        }}
      >
        <Tab eventKey="future" title="Upcoming Events">
          <EventFutureSearch />
        </Tab>
        <Tab eventKey="past" title="Past Events">
          <EventPastSearch />
        </Tab>
        <Tab eventKey="on-demand" title="On-Demand Events">
          <OnDemandEventSearch />
        </Tab>
        <Tab eventKey="cancelled" title="Cancelled Events">
          <CancelledEventSearch />
        </Tab>
      </Tabs>
    </>
  );
};
